import Repo from "../../Repository/Repo";
import { Toast } from "../components/Toast";
import { vehiclesClear } from "./vehicleSlice";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import { getVehicleReport, vehicleReportsClear } from "./vehicleReportSlice";

export const saveVehicle = async (state, dispatch) => {
  let companyCode = localStorage.getItem("companyCode");
  let id = uuidv4();
  let _id = id.replaceAll("-", "");
  try {
    let { data } = await Repo.vehicle({
      request: {
        method: "saveVehicle",
        data: { ...state, company_code: companyCode, _id },
      },
    });
    if (data.response.data.vehicleId) {
      Toast("success", "Added Successfully");
    } else {
      dispatch(vehiclesClear());
      Toast("error", "Not Added");
    }
  } catch (err) {
    console.log("err:", err);
    Toast("error", "Error");
    dispatch(vehiclesClear());
  }
};
export const saveVehicleExpense = async (state, dispatch) => {
  let date = moment().format("DD-MM-YYYY");
  try {
    let { data } = await Repo.vehicle({
      request: {
        method: "saveVehicleExpense",
        data: {
          vehicleId: state.driverName._id,
          checkIn: state.checkIn,
          date: date,
        },
      },
    });
    if (data.response.data.vehicleExpenseId) {
      let obj = {
        company_code: localStorage.getItem("companyCode"),
        vehicleName: "",
        driverName: "",
        startDate: date,
        endDate: date,
      };
      Toast("success", "Entry Added Successfully");
      dispatch(getVehicleReport(obj));
    } else {
      dispatch(vehicleReportsClear());
      Toast("error", "Not Added");
    }
  } catch (err) {
    console.log("err:", err);
    Toast("error", "Error");
    dispatch(vehicleReportsClear());
  }
};
export const updateVehicleExpense = async (_id, arg, dispatch) => {
  let date = moment().format("DD-MM-YYYY");
  try {
    let { data } = await Repo.vehicle({
      request: {
        method: "updateVehicleExpense",
        data: {
          _id: _id,
          checkOut: arg,
        },
      },
    });
    if (data.response.data.vehicleId) {
      let obj = {
        company_code: localStorage.getItem("companyCode"),
        vehicleName: "",
        driverName: "",
        startDate: date,
        endDate: date,
      };
      Toast("success", "Entry Added Successfully");
      dispatch(getVehicleReport(obj));
    } else {
      dispatch(vehicleReportsClear());
      Toast("error", "Entry Not Updated");
    }
  } catch (err) {
    console.log("err:", err);
    Toast("error", "Error");
    dispatch(vehicleReportsClear());
  }
};
export const deleteVehicle = async (_id, dispatch) => {
  try {
    let { data } = await Repo.vehicle({
      request: {
        method: "deleteVehicle",
        data: { _id },
      },
    });
    if (data.response.data.vehicleId) {
      Toast("success", "Added Successfully");
    } else {
      dispatch(vehiclesClear());
      Toast("error", "Not Added");
    }
  } catch (err) {
    console.log("err:", err);
    Toast("error", "Error");
    dispatch(vehiclesClear());
  }
};
export const updateVehicle = async (_id, values, dispatch) => {
  try {
    let { data } = await Repo.vehicle({
      request: {
        method: "updateVehicle",
        data: { _id, ...values },
      },
    });
    if (data.response.data.vehicleId) {
      Toast("success", "Added Successfully");
    } else {
      dispatch(vehiclesClear());
      Toast("error", "Not Added");
    }
  } catch (err) {
    console.log("err:", err);
    Toast("error", "Error");
    dispatch(vehiclesClear());
  }
};
